import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import ProductOffers from './ProductOffers.js';

const ProductOffersContainer = (_param)=>{
    var { labels: labelsProp  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "labels"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>labelsProp !== null && labelsProp !== void 0 ? labelsProp : {
            title: getLabel('products.offers.title')
        }
    , [
        getLabel,
        labelsProp
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, props, {
        labels: labels
    }));
};
var ProductOffersContainer$1 = ProductOffersContainer;

export { ProductOffersContainer$1 as default };
//# sourceMappingURL=ProductOffersContainer.js.map
